import { render, staticRenderFns } from "./AnswerTextarea.vue?vue&type=template&id=11ed88f1"
import script from "./AnswerTextarea.vue?vue&type=script&lang=js"
export * from "./AnswerTextarea.vue?vue&type=script&lang=js"
import style0 from "./AnswerTextarea.vue?vue&type=style&index=0&id=11ed88f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports